export const processHtml = (html) => {
    if (!html || typeof document === 'undefined') return html;

    // Create a temporary div to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // 1. Handle blocks with content-style-pdf
    const pdfBlocks = tempDiv.querySelectorAll('.content-style-pdf');
    pdfBlocks.forEach(block => {
        const textContent = block.textContent || '';
        const isExcel = /\.(xlsx|xls|csv)/i.test(textContent);

        if (isExcel) {
            block.classList.remove('content-style-pdf');
            block.classList.add('content-style-excel');

            const img = block.querySelector('img');
            if (img) {
                if (img.src.includes('download-form.svg') || img.src.includes('pdf')) {
                    img.src = '/img/icon/excel.svg';
                }
            }
        }
    });

    // 2. Handle generic links to Excel files (useful for tables)
    const allLinks = tempDiv.querySelectorAll('a');
    allLinks.forEach(link => {
        const href = link.getAttribute('href') || link.href || '';
        const isExcel = /\.(xlsx|xls|csv)/i.test(href);

        if (isExcel) {
            // Look for PDF icons inside the link
            const icons = link.querySelectorAll('i, span, img');
            icons.forEach(el => {
                if (el.tagName.toLowerCase() === 'i' || el.tagName.toLowerCase() === 'span') {
                    // Match fa-file-pdf, fa-file-pdf-o, etc.
                    if (/fa-file-pdf/i.test(el.className)) {
                        el.className = el.className.replace(/fa-file-pdf(-o)?/gi, 'fa-file-excel');
                        el.style.color = '#217346'; // Excel green
                    }
                } else if (el.tagName.toLowerCase() === 'img') {
                    if (el.src.includes('pdf') || el.src.includes('download-form.svg')) {
                        el.src = '/img/icon/excel.svg';
                    }
                }
            });

            // Also check if the link itself is just text and maybe we should add an icon? 
            // For now, let's just replace existing ones.
        }
    });

    // 3. Handle cases where the icon is outside the link but in the same cell
    const allIcons = tempDiv.querySelectorAll('i, img');
    allIcons.forEach(icon => {
        const isPdfIcon = (icon.tagName.toLowerCase() === 'i' && /fa-file-pdf/i.test(icon.className)) ||
            (icon.tagName.toLowerCase() === 'img' && (icon.src.includes('pdf') || icon.src.includes('download-form.svg')));

        if (isPdfIcon) {
            const parentCell = icon.closest('td, li, div');
            if (parentCell) {
                const link = parentCell.querySelector('a');
                if (link) {
                    const href = link.getAttribute('href') || link.href || '';
                    if (/\.(xlsx|xls|csv)/i.test(href)) {
                        if (icon.tagName.toLowerCase() === 'i') {
                            icon.className = icon.className.replace(/fa-file-pdf(-o)?/gi, 'fa-file-excel');
                            icon.style.color = '#217346';
                        } else {
                            icon.src = '/img/icon/excel.svg';
                        }
                    }
                }
            }
        }
    });

    return tempDiv.innerHTML;
};
